import { patchRequest } from '@/core';
import { savedTripSearches } from '@/requests';

export default async function updateMultipleSavedTripSearchesRequest(patch) {
	let url = savedTripSearches.getPath();
	let response = await patchRequest(url, {}, patch);
	return response;
}
